import { oz } from '@weft/utils';

export const HomePageCurrentBillingCycleInformationSchema = oz.object({
  overchargesSum: oz.number().nonnegative(),
  totalInvoicesSum: oz.number(),
  totalInvoicesCount: oz.number().nonnegative(),
  inReviewInvoicesCount: oz.number().nonnegative(),
  forApprovalInvoicesCount: oz.number().nonnegative(),
  overageInvoicesCount: oz.number().nonnegative(),
}).openapi('HomePageCurrentBillingCycleInformation');

export type HomePageCurrentBillingCycleInformation = oz.infer<typeof HomePageCurrentBillingCycleInformationSchema>;
